/**
 * @generated SignedSource<<31ec8e401771101e76d1eceabcc5820c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfileCardRelay_query$data = {
  readonly activity: {
    readonly workedOn: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly object: {
            readonly data: {
              readonly __typename: "BitbucketPullRequest";
              readonly href: AGG$URL | null | undefined;
            } | {
              readonly __typename: "ConfluenceBlogPost";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ConfluencePage";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ConfluenceWhiteboard";
              readonly links: {
                readonly base: string | null | undefined;
                readonly webUi: string | null | undefined;
              } | null | undefined;
            } | {
              readonly __typename: "ExternalDocument";
              readonly url: string | null | undefined;
            } | {
              readonly __typename: "JiraIssue";
              readonly webUrl: AGG$URL | null | undefined;
            } | {
              readonly __typename: "LoomVideo";
              readonly loomUrl: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
          };
        };
      }>;
    };
  } | null | undefined;
  readonly knowledgeDiscovery: {
    readonly singleUser: {
      readonly __typename: "KnowledgeDiscoverySingleUser";
      readonly user: {
        readonly manager: {
          readonly id: string | null | undefined;
          readonly jobTitle: string | null | undefined;
          readonly name: string | null | undefined;
          readonly picture: string | null | undefined;
        } | null | undefined;
        readonly thirdPartyIntegrations: ReadonlyArray<{
          readonly externalId: string;
          readonly integrationId: string;
          readonly product: string;
        }> | null | undefined;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly accountId: string;
    readonly appType?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly extendedProfile?: {
      readonly department: string | null | undefined;
      readonly jobTitle: string | null | undefined;
      readonly location: string | null | undefined;
      readonly organization: string | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "UserProfileCardRelay_query";
};
export type UserProfileCardRelay_query$key = {
  readonly " $data"?: UserProfileCardRelay_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileCardRelay_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = {
  "kind": "ScalarField",
  "name": "picture"
},
v2 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userAri"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userIdString"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "viewerId"
    }
  ],
  "kind": "Fragment",
  "name": "UserProfileCardRelay_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "userId"
        }
      ],
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "email"
            },
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "department"
                },
                {
                  "kind": "ScalarField",
                  "name": "location"
                },
                {
                  "kind": "ScalarField",
                  "name": "organization"
                }
              ]
            }
          ],
          "type": "AtlassianAccountUser"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "appType"
            }
          ],
          "type": "AppUser"
        }
      ]
    },
    {
      "concreteType": "Activity",
      "kind": "LinkedField",
      "name": "activity",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "fields": [
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "actors.0",
                      "variableName": "userAri"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "actors"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 3
            }
          ],
          "concreteType": "ActivityConnection",
          "kind": "LinkedField",
          "name": "workedOn",
          "plural": false,
          "selections": [
            {
              "concreteType": "ActivityItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "ActivityNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "ActivityObject",
                      "kind": "LinkedField",
                      "name": "object",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "data",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "ConfluencePageLinks",
                                  "kind": "LinkedField",
                                  "name": "links",
                                  "plural": false,
                                  "selections": (v4/*: any*/)
                                }
                              ],
                              "type": "ConfluencePage"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "ConfluenceBlogPostLinks",
                                  "kind": "LinkedField",
                                  "name": "links",
                                  "plural": false,
                                  "selections": (v4/*: any*/)
                                }
                              ],
                              "type": "ConfluenceBlogPost"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "ConfluenceWhiteboardLinks",
                                  "kind": "LinkedField",
                                  "name": "links",
                                  "plural": false,
                                  "selections": (v4/*: any*/)
                                }
                              ],
                              "type": "ConfluenceWhiteboard"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "webUrl"
                                }
                              ],
                              "type": "JiraIssue"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "url"
                                }
                              ],
                              "type": "ExternalDocument"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "href"
                                }
                              ],
                              "type": "BitbucketPullRequest"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "loomUrl",
                                  "kind": "ScalarField",
                                  "name": "url"
                                }
                              ],
                              "type": "LoomVideo"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "KnowledgeDiscoveryQueryApi",
      "kind": "LinkedField",
      "name": "knowledgeDiscovery",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "accountId",
              "variableName": "userIdString"
            },
            {
              "kind": "Variable",
              "name": "orgId",
              "variableName": "orgId"
            },
            {
              "kind": "Variable",
              "name": "requestingUserId",
              "variableName": "viewerId"
            },
            {
              "kind": "Variable",
              "name": "tenantId",
              "variableName": "cloudId"
            }
          ],
          "kind": "LinkedField",
          "name": "singleUser",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "KnowledgeDiscoveryUserProfile",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "KnowledgeDiscoveryUserManager",
                      "kind": "LinkedField",
                      "name": "manager",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "id"
                        },
                        (v2/*: any*/),
                        (v1/*: any*/),
                        (v0/*: any*/)
                      ]
                    },
                    {
                      "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                      "kind": "LinkedField",
                      "name": "thirdPartyIntegrations",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "externalId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "integrationId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "product"
                        }
                      ]
                    }
                  ]
                }
              ],
              "type": "KnowledgeDiscoverySingleUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "0c1c29212a450e30cc5095a7c759b086";

export default node;
